//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { getIsSocialDashboardsEnabled } from '@account-settings/redux/accountSettings/selectors/getIsSocialDashboardsEnabled';
import { NavDropdown } from '@legacy-components/nav3/navigation-menus/NavDropdown';
import { NavDropdownItem } from '@legacy-components/nav3/navigation-menus/NavDropdownItem';
import { NAV_DROPDOWN_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { getIsSocialFeatureEnabled } from '@universal-scheduling/redux/scheduler/selectors/getIsSocialFeatureEnabled';

export const PublishingMenu = () => {
  const isSocialDashboardsEnabled = useSelector(getIsSocialDashboardsEnabled);
  const isSocialEnabled = useSelector(getIsSocialFeatureEnabled);

  return (
    <NavDropdown>
      {isSocialDashboardsEnabled && isSocialEnabled && (
        <NavDropdownItem
          primary='Schedule'
          state='schedule'
          trackingId={NAV_DROPDOWN_ITEMS_TRACKING_ID.SCHEDULE_DROPDOWN}
        />
      )}
      {isSocialDashboardsEnabled && (
        <NavDropdownItem
          primary='Analytics'
          state='instagramAccount'
          trackingId={NAV_DROPDOWN_ITEMS_TRACKING_ID.ANALYTICS_DROPDOWN}
        />
      )}
    </NavDropdown>
  );
};
